export const DETAIL_MOVIE_REQUEST = "detailMovieReducer/DETAIL_MOVIE_REQUEST";
export const DETAIL_MOVIE_SUCCESS ="detailMovieReducer/DETAIL_MOVIE_SUCCESS";
export const DETAIL_MOVIE_FAILED ="detailMovieReducer/DETAIL_MOVIE_FAILED";